// extracted by mini-css-extract-plugin
export default {"fs":"_1b029bdd35 _97e38ffbb2"};